import axios from "axios";
import React from "react";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import DeleteDialog from "../../../components/DeleteDialog";
import { TwInitialsAvatar, TwListMoreButton, TwMoreOptions } from "../../../components/tailwind";
import { useLocalStorage } from "../../../hooks";
import { setSectionLoading } from "../../../redux/reducers/loadingReducer";
import { userState } from "../../../redux/reducers/userReducer";
import { getUrlForBookings, getUrlForUsers } from "../../../utils/confighelpers";
import ErrorDialog from "../../confirmationModals/ErrorDialog";


const resource_type_list = {
  "host": "Host",
  // "employee": "Employee",
  "venue": "Venue",
  "court": "Playing field or court",
  "table": "Table",
  "stylist": "Stylist",
  "masseuse": "Masseuse",
  "beautician": "Beautician",
  "other": "Other",
};

export default function MyResourceTile({
  handleSessionClick,
  reload,
  item,
  allResources,
}) {

  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const [delDialogOpen, setDelDialogOpen] = React.useState(false);
  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
  const [errorText, setErrorText] = React.useState(false);

  const deleteResource = async (item) => {
    setDelDialogOpen(false)
    dispatch(setSectionLoading(true));
    const manageServiceBookingsConfig = {
      method: "get",
      url: `${getUrlForBookings()}getServiceBooking?teacherId=${userReduxState.userData?._id}&resourceId=${item._id}&page=${1}&limit=5&filterBy=confirmed&startDate=${moment().format("YYYY-MM-DD")}&endDate=${moment().add(10, 'years').format("YYYY-MM-DD")}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const manageServiceBookingsRequest = await axios(manageServiceBookingsConfig);
    if (manageServiceBookingsRequest.status === 200) {
      if (manageServiceBookingsRequest.data.data.data.length) {
        //error
        setErrorText("Cannot delete a resource with active appointments in future. Please ensure all upcoming appointments for this resource is cancelled before deleting it.");
        setOpenErrorDialog(true);
      } else {
        // delete
        const manageClassesConfig = {
          method: "put",
          url: `${getUrlForUsers()}updateProfile`,
          headers: {
            "x-access-token": userToken,
          },
          data: {
            myResource: {
              ...item,
              action: "delete"
            }
          },
        };
        const responce = await axios(manageClassesConfig);
        if (responce.status === 200) {
        }

        reload();
      }
    } else {
    }
    // reload();
    dispatch(setSectionLoading(false));
  };

  return (
    <li className="flex items-center justify-between gap-x-6 p-5 rounded-xl hover:bg-list-hover">
      <div className="flex flex-1 min-w-0 gap-x-4" onClick={() => { handleSessionClick(); }}>
        <div className="size-12 flex justify-center items-center rounded-full">

          {item.profilePic ? (<img
            className={
              "w-12 max-w-12 h-12 rounded-full"
            }
            src={item.profilePic}
            alt={""}
          />) : (
            <TwInitialsAvatar name={item?.fullName || ""} className="sm:size-12" />
          )}
        </div>
        <div className="min-w-0 flex-auto text-brown-coffee">
          <p className="truncate text-base font-bold">{item?.fullName}</p>
          <p className="mt-1 truncate text-xs capitalize">{resource_type_list[item.resourceType]}</p>
        </div>
      </div>
      <div className="flex flex-none items-center gap-x-4">
        <TwMoreOptions
          options={[
            <TwListMoreButton
              className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
              onClick={() => {
                handleSessionClick();
              }}
            >
              Edit
            </TwListMoreButton>,
            allResources.length > 1 && <TwListMoreButton
              className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
              onClick={() => {
                setDelDialogOpen(true)
              }}
            >
              Delete
            </TwListMoreButton>

          ]} />
      </div>
      <DeleteDialog
        open={delDialogOpen}
        title={"WARNING"}
        // message={"Are you sure you want to cancel this booking?"}
        message={"Are you sure you want to delete this resource?"}
        type={""}
        handleClose={() => setDelDialogOpen(false)}
        handleDelete={() => { deleteResource(item); }}
      />

      <ErrorDialog
        open={openErrorDialog}
        text={errorText}
        onClose={() => setOpenErrorDialog(false)}
      />
    </li>
  );
}
